import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';

type Props = {
  className?: string;
  height?: number;
  title?: string;
  width?: number;
};

const DisabledFormIcon = ({
  className = '',
  height = 140,
  title,
  width = 140,
}: Props) => (
  <AccessibleSVG
    className={`disabled-form-icon ${className}`}
    height={height}
    title={title}
    viewBox="0 0 140 140"
    width={width}
  >
    <g fill="none" fillRule="evenodd">
      <ellipse
        cx="28"
        cy="4"
        fill="#E5EFFA"
        rx="28"
        ry="4"
        transform="translate(42 132)"
      />
      <rect fill="#E5EFFA" height="80" rx="4" width="56" x="50" y="17" />
      <path
        d="M38 36h48a4 4 0 0 1 4 4v72a4 4 0 0 1-4 4H38a4 4 0 0 1-4-4V40a4 4 0 0 1 4-4z"
        stroke="#0061D5"
        strokeDasharray="2,5"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M46 26h38.343a4 4 0 0 1 2.829 1.172l9.656 9.656A4 4 0 0 1 98 39.657V106l-10-8-8 8-10-5-9 5-9-8-10 5V30a4 4 0 0 1 4-4z"
        fill="#FFF"
        stroke="#0061D5"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M59 57a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2h8zm30-4a1 1 0 0 1 0 2H51a1 1 0 0 1 0-2h38zm0-4a1 1 0 0 1 0 2H51a1 1 0 0 1 0-2h38zm-16-6a1 1 0 0 1 0 2H51a1 1 0 0 1 0-2h22z"
        fill="#0061D5"
      />
      <path
        d="M55 66h30a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H55a4 4 0 0 1-4-4V70a4 4 0 0 1 4-4z"
        stroke="#0061D5"
        strokeDasharray="2,5"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M56 68h28a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H56a3 3 0 0 1-3-3V71a3 3 0 0 1 3-3z"
        fill="#E5EFFA"
      />
      <g transform="translate(75 61)">
        <rect
          fill="#FFF"
          height="8.421"
          rx="1.2"
          stroke="#0061D5"
          strokeWidth="2"
          transform="scale(-1 1) rotate(45 0 -41.948)"
          width="4.795"
          x="27.219"
          y="25.342"
        />
        <path
          d="M34.835 30.492a1.2 1.2 0 0 1 1.697-.003l10.215 10.216a1.203 1.203 0 0 1-.003 1.697l-4.234 4.233a1.2 1.2 0 0 1-1.697.004L30.598 36.423a1.203 1.203 0 0 1 .003-1.697zM16.185 0c8.938 0 16.184 7.271 16.184 16.24 0 8.97-7.246 16.241-16.184 16.241C7.246 32.481 0 25.21 0 16.241 0 7.27 7.246 0 16.185 0z"
          fill="#FFF"
          stroke="#0061D5"
          strokeWidth="2"
        />
        <path
          d="M33.964 34.665a.607.607 0 0 1 .854-.001l8.505 8.504c.23.231.235.618-.002.854l-.84.84a.607.607 0 0 1-.854.002l-8.504-8.505a.608.608 0 0 1 .001-.854zM15.884 2.406c4.413 0 8.33 2.126 10.79 5.412.468.625.883 1.29 1.239 1.992.933 1.84-10.523-6.465-16.9 0-6.377 6.464.169 19.02-1.798 17.895A13.537 13.537 0 0 1 2.398 15.94c0-7.475 6.038-13.534 13.487-13.534z"
          fill="#E5EFFA"
        />
        <path
          d="M16.185 5.414c-5.96 0-10.79 4.847-10.79 10.827 0 1.428.276 2.793.777 4.042"
          stroke="#0061D5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
      <path
        d="M85 27v8a4 4 0 0 0 4 4h8"
        fill="#E5EFFA"
        stroke="#0061D5"
        strokeWidth="2"
      />
      <path
        d="M8.014 80l.089.008a.508.508 0 0 1 .406.398l.009.09v.646c.153.088.28.216.369.369h.647c.247 0 .446.178.487.413l.007.09-.008.089a.508.508 0 0 1-.397.406l-.089.009h-.647c-.089.153-.216.28-.37.369v.633a.511.511 0 0 1-.412.5l-.09.008-.09-.008a.508.508 0 0 1-.406-.397l-.008-.089v-.647a1.012 1.012 0 0 1-.37-.37h-.647a.493.493 0 0 1-.486-.412L6 82.015l.008-.09a.508.508 0 0 1 .397-.406l.089-.008h.648c.088-.153.216-.28.369-.37v-.647c0-.247.178-.445.413-.486l.09-.008zM21.014 62l.089.008a.508.508 0 0 1 .406.398l.009.09v.646c.153.088.28.216.369.369h.647c.247 0 .446.178.487.413l.007.09-.008.089a.508.508 0 0 1-.397.406l-.089.009h-.647c-.089.153-.216.28-.37.369v.633a.511.511 0 0 1-.412.5l-.09.008-.09-.008a.508.508 0 0 1-.406-.397l-.008-.089v-.647a1.012 1.012 0 0 1-.37-.37h-.647a.493.493 0 0 1-.486-.412l-.008-.09.008-.09a.508.508 0 0 1 .397-.406l.089-.008h.648c.088-.153.216-.28.369-.37v-.647c0-.247.178-.445.413-.486l.09-.008zM8.014 34l.089.008a.508.508 0 0 1 .406.398l.009.09v.646c.153.088.28.216.369.369h.647c.247 0 .446.178.487.413l.007.09-.008.089a.508.508 0 0 1-.397.406l-.089.009h-.647c-.089.153-.216.28-.37.369v.633a.511.511 0 0 1-.412.5l-.09.008-.09-.008a.508.508 0 0 1-.406-.397l-.008-.089v-.647a1.012 1.012 0 0 1-.37-.37h-.647a.493.493 0 0 1-.486-.412L6 36.015l.008-.09a.508.508 0 0 1 .397-.406l.089-.008h.648c.088-.153.216-.28.369-.37v-.647c0-.247.178-.445.413-.486l.09-.008zM123.014 17l.089.008a.508.508 0 0 1 .406.398l.009.09v.646c.153.088.28.216.369.369h.647c.247 0 .446.178.487.413l.007.09-.008.089a.508.508 0 0 1-.397.406l-.089.009h-.647c-.089.153-.216.28-.37.369v.633a.511.511 0 0 1-.412.5l-.09.008-.09-.008a.508.508 0 0 1-.406-.397l-.008-.089v-.647a1.012 1.012 0 0 1-.37-.37h-.647a.493.493 0 0 1-.486-.412l-.008-.09.008-.09a.508.508 0 0 1 .397-.406l.089-.008h.648c.088-.153.216-.28.369-.37v-.647c0-.247.178-.445.413-.486l.09-.008zM52.014 0l.089.008a.508.508 0 0 1 .406.398l.009.09v.646c.153.088.28.216.369.369h.647c.247 0 .446.178.487.413l.007.09-.008.089a.508.508 0 0 1-.397.406l-.089.009h-.647c-.089.153-.216.28-.37.369v.633a.511.511 0 0 1-.412.5l-.09.008-.09-.008a.508.508 0 0 1-.406-.397l-.008-.089v-.647a1.012 1.012 0 0 1-.37-.37h-.647a.493.493 0 0 1-.486-.412L50 2.015l.008-.09a.508.508 0 0 1 .397-.406l.089-.008h.648c.088-.153.216-.28.369-.37V.495c0-.247.178-.445.413-.486l.09-.008zM119.259 58l.07.008a.318.318 0 0 1 .236.23l.009.072v.404a.633.633 0 0 1 .23.23h.405c.149 0 .27.104.3.243l.009.072-.008.07a.318.318 0 0 1-.23.236l-.07.009h-.406a.633.633 0 0 1-.23.23v.396a.32.32 0 0 1-.243.31l-.072.008-.07-.008a.318.318 0 0 1-.236-.23l-.009-.07v-.406a.633.633 0 0 1-.23-.23h-.405a.308.308 0 0 1-.301-.243L118 59.26l.008-.07a.318.318 0 0 1 .23-.236l.07-.009h.406a.633.633 0 0 1 .23-.23v-.405c0-.149.104-.27.243-.301l.072-.008zM24.259 16l.07.008a.318.318 0 0 1 .236.23l.009.072v.404a.633.633 0 0 1 .23.23h.405c.149 0 .27.104.3.243l.009.072-.008.07a.318.318 0 0 1-.23.236l-.07.009h-.406a.633.633 0 0 1-.23.23v.396a.32.32 0 0 1-.243.31l-.072.008-.07-.008a.318.318 0 0 1-.236-.23l-.009-.07v-.406a.633.633 0 0 1-.23-.23h-.405a.308.308 0 0 1-.301-.243L23 17.26l.008-.07a.318.318 0 0 1 .23-.236l.07-.009h.406a.633.633 0 0 1 .23-.23v-.405c0-.149.104-.27.243-.301l.072-.008zM92.259 7l.07.008a.318.318 0 0 1 .236.23l.009.072v.404a.633.633 0 0 1 .23.23h.405c.149 0 .27.104.3.243l.009.072-.008.07a.318.318 0 0 1-.23.236l-.07.009h-.406a.633.633 0 0 1-.23.23V9.2a.32.32 0 0 1-.243.31l-.072.008-.07-.008a.318.318 0 0 1-.236-.23l-.009-.07v-.406a.633.633 0 0 1-.23-.23h-.405a.308.308 0 0 1-.301-.243L91 8.26l.008-.07a.318.318 0 0 1 .23-.236l.07-.009h.406a.633.633 0 0 1 .23-.23v-.405c0-.149.104-.27.243-.301L92.259 7zM136.259 77l.07.008a.318.318 0 0 1 .236.23l.009.072v.404a.633.633 0 0 1 .23.23h.405c.149 0 .27.104.3.243l.009.072-.008.07a.318.318 0 0 1-.23.236l-.07.009h-.406a.633.633 0 0 1-.23.23v.396a.32.32 0 0 1-.243.31l-.072.008-.07-.008a.318.318 0 0 1-.236-.23l-.009-.07v-.406a.633.633 0 0 1-.23-.23h-.405a.308.308 0 0 1-.301-.243L135 78.26l.008-.07a.318.318 0 0 1 .23-.236l.07-.009h.406a.633.633 0 0 1 .23-.23v-.405c0-.149.104-.27.243-.301l.072-.008z"
        fill="#0061D5"
      />
    </g>
  </AccessibleSVG>
);

export default DisabledFormIcon;
